import {InnerFilters} from 'types';
import {BlockingAuditParams} from 'types/blocking-audit';

export const mapBlockingAuditFilters = (filters: InnerFilters): BlockingAuditParams => {
    const text = (key: string) => {
        const item = filters[key];
        const value = item && typeof item === 'object' && 'value' in item ? item.value : item;
        return typeof value === 'string' ? value.trim() || undefined : undefined;
    };
    const [from, to] = (filters.eventTimestamp as [Date | null, Date | null]) || [];
    return {
        userFullName: text('userFullName'),
        organizationName: text('organizationName'),
        organizationTin: text('organizationTin'),
        eventType: text('eventType'),
        documentId: text('documentId'),
        blockingId: text('blockingId'),
        markingCode: text('markingCode'),
        reason: text('reason'),
        unblockingReason: text('unblockingReason'),
        sourceFormation: text('sourceFormation'),
        from: from
            ? new Date(from.getFullYear(), from.getMonth(), from.getDate()).toISOString()
            : undefined,
        to: to
            ? new Date(to.getFullYear(), to.getMonth(), to.getDate(), 23, 59, 59, 999).toISOString()
            : undefined,
    };
};
